/*eslint-disable */

import { bus } from '@/main';
import {
mapGetters,
} from 'vuex';
import sharedModelPopup from '../shared-models/index.vue';
import toast from '@/services/toast';

export default {
  name: 'created-models-list',
  components: {
    'shared-model-popup' : sharedModelPopup
  },
  props: [],
  data () {
    return {
      createdAlgoList:null,
      createdAlgoListResults:[],
      pubModelId:'',
      publicModelPopup:false,
      userDetails:null,
      updateModelName:'',
      updateModelNameId:'',
      updateModelNameState:false,
      sharedModelInfo:null,
      sharedModelPopup:false,
      submitted:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserDetailsFun(){
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data;
      return
    },
  },
  mounted () {
    this.getSelfUserDetailsFun
    this.getCreatedModelsListFunc()
    bus.$on('sharedModelPopupBus', (data) => {
      this.sharedModelPopup = data
    })
  },
  methods: {
    getCreatedModelsListFunc() {
      this.$store.dispatch('getModelListForAITaskFun').then((res) => {
        this.createdAlgoList = res.data.data
        this.createdAlgoListResults = this.createdAlgoList.results 
      })
    },
    makeModelPublicMethod(modelId){
      this.pubModelId = modelId
      this.publicModelPopup = true
      document.body.classList.add('body_right_scroll_remove')
    },
    clodesModelPublicPopupMethod(){
      this.pubModelId = ''
      this.publicModelPopup = false
      document.body.classList.remove('body_right_scroll_remove')
    },
    userStatusUpdatedFun(userStatus){
      var is_public = userStatus
      if(userStatus == false){
        is_public = true
      }else{
        is_public = false
      }
      let data = new FormData();
      data.append('is_public', is_public);
      this.$store.dispatch('updateProfileFun', data)
        .then((res) => {
          this.getCreatedModelsListFunc();
          toast.success(res.data.msg);
        }).catch((err) => {
          toast.error(err.data.user_msg || err.data.data.email);
        })
      return;
    },
    modelNameUpdatePopupOpenFun(modelId, ModelName){
      this.updateModelName = ModelName
      this.updateModelNameId = modelId
      this.updateModelNameState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    updateModelNameaBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            name : this.updateModelName
          }
          this.$store.dispatch('updateModelDetailsByIDForAIFun',{data:{data:data,id:this.updateModelNameId}})
            .then((res) => {  
              this.getCreatedModelsListFunc();
              toast.success(res.data.msg);
              this.submitted =  false;
              this.closeUpdateModelNamePopup();
            }).catch((err) => {
              this.submitted =  false;
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeUpdateModelNamePopup(){
      this.updateModelNameState = false
      document.body.classList.remove('body_right_scroll_remove')
    },
    sharedModelPopupMethod(modelId){
      this.sharedModelInfo = modelId
      this.sharedModelPopup = true
      document.body.classList.add('body_right_scroll_remove')
    },
  },
  watch:{
    getSelfUserDetailsFun(){
      return this.$store.getters.acUserDetailsStateGetters;
    },
  }
}